import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import DOMPurify from "dompurify";

const ModalTratamientoDatos = (props) => {
  const { modal, texto, callbackSave, callbackModal } = props;
  const [checked, setChecked] = useState(false);
  const onClickClose = () => {
    callbackModal();
  };

  const renderFooterAC = (stateMethod) => {
    return (
      <div className="flex justify-content-center">
        <Button
          label="Cancelar"
          icon="pi pi-times-circle"
          onClick={onClickClose}
          severity="info"
        />
        <Button
          label="Aceptar"
          icon="pi pi-check-square"
          type="button"
          severity="success"
          disabled={!checked}
          onClick={(e) => {
            callbackSave();
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <Dialog
        visible={modal}
        style={{ width: "50vw" }}
        header="Declaración y Consentimiento"
        modal
        onHide={onClickClose}
        footer={renderFooterAC(null)}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(texto),
          }}
          style={{ textAlign: "justify" }}
        />
        <div className="flex flex-wrap justify-content-center gap-3">
          <Checkbox
            id="valida"
            name="valida"
            onChange={(e) => setChecked(e.checked)}
            checked={checked}
          ></Checkbox>
          <label htmlFor="valida" className="ml-2">
            He leído y estoy de acuerdo.
          </label>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalTratamientoDatos;
